// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__3UigD","h1":"h1__3p7re","section":"section__IqvAe"};